import Home from './home.js'
import Glam from './glam.js'
import Eshop from './eshop.js'
import Topvalu from './topvalu.js'
$(document).ready(function() {
	new WOW().init();
	PDFObject.embed("https://pdfobject.com/pdf/sample-3pp.pdf", "#pdfOb");
	document.querySelector('.home-page') && Home();
	document.querySelector('.glam-page') && Glam();
	document.querySelector('.eshop-page') && Eshop();
	document.querySelector('.topvalu-page') && Topvalu();



	$('.goto').click(function(e) {
		e.preventDefault();
		$(this).addClass('active').closest('li').siblings('li').find('a').removeClass('active');
		let id = $(this).attr('href');
		let offset = $(id).offset().top;
		$('html,body').animate({
	        scrollTop: offset
	    }, 700);

	})
	

})


// WEBPACK FOOTER //
// ./src/js/index.js